// Generated by CoffeeScript 1.9.3
var _BlockPrependor;

module.exports = _BlockPrependor = (function() {
  function _BlockPrependor(_config) {
    this._config = _config;
  }

  _BlockPrependor.prototype.render = function(options) {
    return this._render(options);
  };

  return _BlockPrependor;

})();



//////////////////
// WEBPACK FOOTER
// ./~/renderkid/lib/layout/block/blockPrependor/_BlockPrependor.js
// module id = 404
// module chunks = 0